module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq743-9c588495271d13f95ef301ec50c901da.jpg";